// extracted by mini-css-extract-plugin
export default {"user":"styles_user__VGzZD","edit":"styles_edit__x2Jde","delete":"styles_delete__o2s3s","table_container":"styles_table_container__zu+bE","userImage":"styles_userImage__iup61"};